module.exports = __webpack_public_path__ + "static/img/1.c7097b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/sp/1.png
// module id = kAS5
// module chunks = 0